<template>
  <div v-if="isVisible">
    <v-tooltip
      v-model="isTooltipVisible"
      right
    >
      <template v-slot:activator="{}">
        <v-list-item
          :id="url.replace(/[^a-zA-Z0-9]/g, '')"
          :to="isExternalLink ? '' : url"
          :href="isExternalLink ? url : ''"
          :class="cssClass"
          @mouseenter="startTooltipShowTimer"
          @mouseleave="clearTooltipShowTimer"
        >
          <v-list-item-icon>
            <v-icon class="sidebar--account__icon">{{ icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title :class="titleClass">
              {{ title }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
      <span>{{ title }}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
    url: { type: String, required: true },
    cssClass: { type: String, default: '' },
    icon: { type: String, default: '' },
    title: { type: String, required: true },
    isAccountSidebarOpen: { type: Boolean, required: true },
    isExternalLink: { type: Boolean, default: false },
    type: { type: String, default: 'link' },
    isForTreasurersOnly: { type: Boolean, default: false },
    isForTreasurerOrConsultant: { type: Boolean, default: false },
    isTreasurer: { type: Boolean, default: false },
    isTreasurerOrConsultant: { type: Boolean, default: false },
  },
  data() {
    return {
      isTooltipVisible: false,
      timeoutId: null,
    }
  },
  computed: {
    titleClass() {
      switch (this.type) {
        case 'subLink':
          return 'font-weight-regular ps-4';
        case 'groupTitle':
        case 'link':
        default:
          return '';
      }
    },
    isVisible() {
      return (!this.isForTreasurersOnly || this.isTreasurer) && (!this.isForTreasurerOrConsultant || this.isTreasurerOrConsultant);
    },
  },
  watch: {
  },
  mounted() {
  },
  methods: {
    startTooltipShowTimer() {
      if (this.isAccountSidebarOpen) {
        return;
      }

      this.timeoutId = setTimeout(() => {
        this.isTooltipVisible = true;
      }, 400);
    },
    clearTooltipShowTimer() {
      if (this.isAccountSidebarOpen) {
        return;
      }

      clearTimeout(this.timeoutId);
      this.isTooltipVisible = false;
    },
  }
}
</script>

<style lang="scss" scoped>
</style>
